import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.syncRangeOutputs()
  }

  filter(event) {
    const input = event.currentTarget
    const term = input.value.trim().toLowerCase()
    const scope = input.closest("[data-filter-scope]") || this.element
    const items = Array.from(scope.querySelectorAll("[data-filter-item]"))
    let visibleCount = 0

    items.forEach((item) => {
      const hidden = term.length > 0 && !item.textContent.toLowerCase().includes(term)
      item.hidden = hidden
      if (!hidden) visibleCount += 1
    })

    scope.querySelectorAll("[data-empty-state]").forEach((empty) => {
      empty.classList.toggle("is-visible", term.length > 0 && visibleCount === 0)
    })
  }

  select(event) {
    const item = event.currentTarget
    const group = item.closest("[data-selectable-group]")
    if (!group) return

    group.querySelectorAll("[data-selectable]").forEach((candidate) => {
      candidate.classList.toggle("active", candidate === item)
    })
  }

  tab(event) {
    const tab = event.currentTarget
    const tabs = tab.closest("[data-tabs]")
    const scope = tab.closest("[data-tab-scope]") || this.element
    if (!tabs || !tab.dataset.tab) return

    tabs.querySelectorAll("[data-tab]").forEach((item) => {
      const selected = item === tab
      item.classList.toggle("active", selected)
      item.setAttribute("aria-selected", selected ? "true" : "false")
    })

    scope.querySelectorAll("[data-tab-panel]").forEach((panel) => {
      panel.hidden = panel.dataset.tabPanel !== tab.dataset.tab
    })
  }

  loading(event) {
    const button = event.currentTarget
    if (button.dataset.odUiLoading === "true") return

    const label = button.textContent
    button.dataset.odUiLoading = "true"
    button.classList.add("is-loading")
    button.setAttribute("disabled", "true")
    button.textContent = button.dataset.loadingLabel || "处理中..."

    window.setTimeout(() => {
      button.dataset.odUiLoading = "false"
      button.classList.remove("is-loading")
      button.removeAttribute("disabled")
      button.textContent = label
    }, 1000)
  }

  copy(event) {
    const button = event.currentTarget
    const target = document.querySelector(button.dataset.copy)
    const text = target ? target.textContent.trim() : ""
    if (!text) return

    navigator.clipboard?.writeText(text)
    const label = button.textContent
    button.textContent = "已复制"
    window.setTimeout(() => {
      button.textContent = label
    }, 1200)
  }

  range(event) {
    this.syncRangeOutput(event.currentTarget)
  }

  syncRangeOutputs() {
    this.element.querySelectorAll('input[type="range"][data-output]').forEach((range) => {
      this.syncRangeOutput(range)
    })
  }

  syncRangeOutput(range) {
    const output = document.querySelector(range.dataset.output)
    if (output) output.value = range.value
  }
}
